import React, { useEffect, useRef } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useElementsCoordsContext } from '@hooks';
import { useStylesTabs, useStylesTab } from './styles';

const SubMenuChips = ({
  sectionTabValue,
  fetchedStructure,
  tabValue,
  goToLocation,
}) => {
  const tabsRef = useRef();
  const classesTabs = useStylesTabs();
  const classesTab = useStylesTab();
  const { setElementsCoords } = useElementsCoordsContext();

  useEffect(() => {
    setElementsCoords({
      subMenuChips: tabsRef.current.getBoundingClientRect(),
    });
    // eslint-disable-next-line
  }, []);

  return (
    <div ref={tabsRef}>
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={tabValue.index}
        classes={classesTabs}
      >
        {fetchedStructure.length > 0 &&
          fetchedStructure?.map((section, index) => {
            return (
              <Tab
                key={section.id}
                classes={classesTab}
                label={section.name}
                style={
                  section.type === 'DEFAULT'
                    ? { display: 'none' }
                    : { display: 'flex' }
                }
                onClick={() => goToLocation(section, index)}
              />
            );
          })}
      </Tabs>
    </div>
  );
};

export default SubMenuChips;
